import React, { useState, useEffect } from "react";

// External
import _ from "lodash";

// Material-UI
import { makeStyles, InputAdornment } from "@material-ui/core";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import SearchIcon from "@material-ui/icons/Search";

// Internal
import Device from "sccDevice";
import Language from "sccLanguage";
import CustomListItemCollapse from "@Components/CustomListItemCollapse";
import CustomTextField from "@Components/CustomTextField";
import CustomCheckbox from "@Components/CustomCheckbox";

const useStyles = makeStyles((theme) => ({
  GeofenceSyncDevicesListContainer: {
    display: "flex",
    flexDirection: "column",
    padding: "8px 16px",
  },

  GeofenceSyncDevicesList: {
    flex: 1,
    overflowY: "auto",
    display: "flex",
    flexDirection: "column",
  },

  noDevice: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
}));

const GeofenceSyncDevicesList = ({
  checkedDevices,
  allDevices,
  onDeviceClick,
}) => {
  const [filterText, setFilterText] = useState("");
  const [allDevicesInfo, setAllDevicesInfo] = useState([]);
  const [filteredDevices, setFilteredDevices] = useState([]);

  const classes = useStyles();

  useEffect(() => {
    if (allDevices.length > 0) {
      const DevicesInfo = allDevices.map((deviceId) => {
        const deviceInfo = Device.get(deviceId);
        return deviceInfo;
      });

      setAllDevicesInfo(DevicesInfo);
      setFilteredDevices(DevicesInfo);
    }
  }, []);

  //  use debounce to avoid too many re-renders
  const handleFilter = _.debounce((value) => {
    const filterText = value;
    if (filterText !== "") {
      const filteredDevices = allDevicesInfo.filter(
        (deviceInfo) =>
          deviceInfo.name.toLowerCase().includes(filterText.toLowerCase()) ||
          deviceInfo.imei.includes(filterText.toLowerCase())
      );
      setFilteredDevices(filteredDevices);
    } else {
      setFilteredDevices(allDevicesInfo);
    }
  }, 300);

  const handleFilterChange = (e) => {
    setFilterText(e.target.value);
    handleFilter(e.target.value);
  };

  return (
    <React.Fragment>
      <CustomListItemCollapse
        title={Language.translate("Sync").toUpperCase()}
        color="primary"
        collapse={true}
        count={checkedDevices.length}
      >
        {filteredDevices.length > 0 && (
          <CustomTextField
            label=""
            value={filterText}
            fullWidth={true}
            onChange={handleFilterChange}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <SearchIcon />
                </InputAdornment>
              ),
            }}
          />
        )}

        <List>
          {filteredDevices.length > 0 ? (
            filteredDevices.map((deviceInfo) => (
              <ListItem key={deviceInfo.id}>
                <CustomCheckbox
                  key={deviceInfo.id}
                  name={deviceInfo.name}
                  label={deviceInfo.name}
                  color="primary"
                  checked={checkedDevices.includes(deviceInfo.id)}
                  onChange={() => onDeviceClick(deviceInfo.id)}
                />
              </ListItem>
            ))
          ) : (
            <ListItem className={classes.noDevice}>
              {Language.translate("No Device Found")}
            </ListItem>
          )}
        </List>
      </CustomListItemCollapse>
    </React.Fragment>
  );
};

export default GeofenceSyncDevicesList;
